<table mat-table [dataSource]="users" class="mat-elevation-z2 full-width users-table">
  <!-- User Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span i18n="Users List|Users List item 'name' title@@users-list-item-name-title">Name:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell word-wrap">
      {{element.firstName}} {{element.lastName}}
    </td>
  </ng-container>

  <!-- Identifier Column -->
  <ng-container matColumnDef="identifier">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span i18n="Users List|Users List item 'identifier' title@@users-list-item-identifier-title">Identifier:</span>
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell word-wrap spelling">
      {{element.username}}
    </td>
  </ng-container>

  <!-- Password Column -->
  <ng-container matColumnDef="password">
    <th mat-header-cell *matHeaderCellDef class="header-cell">
      <span i18n="Sign In|Password input label@@sign-in-password-label">Password</span>:
    </th>
    <td mat-cell *matCellDef="let element" class="content-cell word-wrap mat-body-strong spelling">
      {{changePassResults?.get(element.id)}}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['name', 'identifier', 'password']"></tr>
  <tr mat-row *matRowDef="let element; columns: ['name', 'identifier', 'password'];"
      class="user-row"></tr>
</table>
